// extracted by mini-css-extract-plugin
export default {"home":"Home_home__zs45u","searchIcon":"Home_searchIcon__hx8Bm"};